import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';

@Component({
    selector: 'app-transport-option-editor-labeling',
    templateUrl: './transport-option-editor-labeling.component.html',
    styleUrls: ['./transport-option-editor-labeling.component.scss'],
    standalone: false
})
export class TransportOptionEditorLabelingComponent implements OnInit {

  @Input() transportOption: TransportOption;

  @Output() changed = new EventEmitter();

  keys = Object.keys;

  optionFormGroup = new FormGroup({
    externalKey: new FormControl(null, []),
    mark: new FormControl(null, []),
    allwaysShowHint: new FormControl(null, [])
  });

  constructor() {

    this.optionFormGroup.valueChanges.subscribe(
      value => {
        if (this.optionFormGroup.dirty) {
          this.transportOption.externalKey = this.optionFormGroup.controls.externalKey.value;
          this.transportOption.mark = this.optionFormGroup.controls.mark.value;
          this.transportOption.allwaysShowHint = value.allwaysShowHint;
          this.changed.emit();
        }
      }
    );
  }

  public ngOnInit() {
    const formdata: any = {
      externalKey: this.transportOption.externalKey,
      mark: this.transportOption.mark,
      allwaysShowHint: this.transportOption.allwaysShowHint
    };
    this.optionFormGroup.reset(formdata);
  }

  public onDictionaryChange($entry: DictionaryEntry) {
    this.optionFormGroup.markAsDirty();
    this.changed.emit();
  }

  public onHintDriverChanged(dictionary: DictionaryEntry) {
    this.transportOption.hintDriver = new DictionaryEntry(dictionary);;
    this.changed.emit();
  }

}
